// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lM-z","isFullWidth":"mM-z","landingPageVideo":"nM-z","play":"oM-z","iframeVideo":"pM-z","playHidden":"qM-z","fullwidth":"rM-z"};